'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = logError;

var _apiClient = require('hub-http/clients/apiClient');

var _apiClient2 = _interopRequireDefault(_apiClient);

var _monitoringHelpers = require('ui-addon-upgrades/_core/common/reliability/monitoringHelpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function logError(product, location) {
  return _apiClient2.default.post(_monitoringHelpers.submitPath, {
    data: (0, _monitoringHelpers.createPayload)(product, location),
    query: _monitoringHelpers.buckyQueryData
  });
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.1086/js/_core/common/reliability/logError.js
// module id = 498
// module chunks = 3 4 5